module.exports = __webpack_public_path__ + "img/38.3e29142e.jpg";